var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListExtractionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.944 6.112C16.507 2.67 13.56 0 10 0C7.244 0 4.85 1.611 3.757 4.15C1.609 4.792 0 6.82 0 9C0 11.757 2.243 14 5 14H16C18.206 14 20 12.206 20 10C19.9985 9.10361 19.6966 8.23358 19.1427 7.52883C18.5888 6.82408 17.8147 6.32526 16.944 6.112ZM16 12H5C3.346 12 2 10.654 2 9C2 7.596 3.199 6.244 4.673 5.985L5.254 5.883L5.446 5.325C6.149 3.274 7.895 2 10 2C12.757 2 15 4.243 15 7V8H16C17.103 8 18 8.897 18 10C18 11.103 17.103 12 16 12Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListExtractionIcon);
export default __webpack_public_path__ + "static/media/ListExtractionIcon.362cbaa11a1aba17c75592417f15b6e5.svg";
export { ForwardRef as ReactComponent };